/**
 * Конвертер таблицы в CSV-формат
 * Поддержка RFC-4180
 *
 * @see http://www.ietf.org/rfc/rfc4180
 * @param table таблица формата [['колонка'] <-- строка] <-- таблица
 * @param options csv параметры
 */
export function tableToCSV(table, options = {}) {
    const colSeparator = options.colSeparator || ',';
    const rowSeparator = '\r\n';
    return table
        .map((row) => {
            return row
                .map((col) => {
                    if (col === null) {
                        return '';
                    }

                    col = col.toString().replace(/"/g, '""');

                    // экранируем колонки с colSeparator, кавычками и newline'ами.
                    if (col.indexOf(colSeparator) !== -1 || col.indexOf('"') !== -1 || col.indexOf('\n') !== -1) {
                        col = `"${col}"`;
                    }

                    return col;
                })
                .join(colSeparator);
        })
        .join(rowSeparator);
}

function toNumber(value) {
    const number = Number(value.trim().replace(',', '.'));

    return isNaN(number) ? value : number;
}

function toNormalizedText(value) {
    return value.toLowerCase().replace(/ё/g, 'е');
}

function toSpacelessText(value) {
    return value.replace(/\s/g, '');
}

function toStrictText(value) {
    return value;
}

function updateAnswerValue(answer, type) {
    if (answer === '') {
        return null;
    }
    switch (type) {
        case 'number':
            return toNumber(answer);
        case 'text':
            return toNormalizedText(answer);
        case 'spaceless':
            return toSpacelessText(answer);
        case 'strict':
            return toStrictText(answer);
        default:
            return answer;
    }
}

export function prepareAnswer(answerValue, typeContent, answerType) {
    const value = updateAnswerValue(String(answerValue), typeContent);

    if (value === null) {
        return {
            type: 'NONE',
        };
    }

    if (answerType) {
        return {
            type: answerType,
            source: value,
        };
    }

    return {
        type: typeContent === 'number' ? 'NUMBER' : 'STRING',
        source: value,
    };
}

export function generateSequenceCheck(answers, elementsType, ordered) {
    if (!answers) {
        return {
            type: 'NONE',
        };
    }

    return {
        type: ordered ? 'SEQUENCE' : 'MULTIUNION',
        sources: answers.map((answer) => {
            if (!answer) {
                return {
                    type: 'NONE',
                };
            }

            return {
                type: elementsType === 'rational' ? 'RATIONAL' : 'STRING',
                source: answer,
            };
        }),
    };
}
